module.exports = __webpack_public_path__ + "static/media/incidence-success.d16ac9db.svg";